<span [uiQuoteStatusColor]="status" class="px-8 py-4 fs-11 font-semibold text-uppercase border-radius-2">{{
  'quote.status.' + status | translate
}}</span>
